

let a = {
    ////正式环境
    baseUrl: "https://www.chunliuedu.com",
    imgUrl: "https://www.chunliuedu.com",
    apiUrl: "https://api.chunliuedu.com",
    wapUrl: "https://m.qinxuejiaoyu.com"
}
let b = {
    ////测试
    baseUrl: "https://www.chunliuedu.com",
    imgUrl: "https://www.chunliuedu.com",
    apiUrl: "https://api.chunliuedu.com",
    wapUrl: "https://m.qinxuejiaoyu.com"
}
// console.log(process.env)
let c = process.env.VUE_APP_TITLE === 'development' ? b : a
export default c;